import http from '@gp/utils/httpTS';


export const fetchStakeholders = (params: any): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/project/stakeholderList',
    method: 'GET',
    params,
    original: true,
  });
};

export const editStakeholders = (params: any): Promise<any> => {
  return http({
    url: '/api/v1/globalpedia_pc/project/stakeholder_edit',
    method: 'POST',
    data: params,
    original: true,
  });
};
